import { render, staticRenderFns } from "./DemandInsightsHeatmap.vue?vue&type=template&id=5580830c&scoped=true"
import script from "./DemandInsightsHeatmap.vue?vue&type=script&lang=js"
export * from "./DemandInsightsHeatmap.vue?vue&type=script&lang=js"
import style0 from "./DemandInsightsHeatmap.vue?vue&type=style&index=0&id=5580830c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5580830c",
  null
  
)

export default component.exports